import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReflectionsState } from '../reducers/reflections.reducer';
import { REFLECTIONS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ReflectionsState>(REFLECTIONS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: ReflectionsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: ReflectionsState) => state.loading);
export const selectReflections = createSelector(selectState, (state: ReflectionsState) => state.reflections);
export const selectTotal = createSelector(selectState, (state: ReflectionsState) => state.total);
export const selectPage = createSelector(selectState, (state: ReflectionsState) => state.page);
export const selectLimit = createSelector(selectState, (state: ReflectionsState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: ReflectionsState) => state.lastParams);
